/* bundle builder */
/* variant picker */
function getSiblingWithClass(element, className) {
  if (element.classList.contains(className)) {
    return element;
  }
  let sibling = element.nextElementSibling;

  while (sibling) {
    if (sibling.classList.contains(className)) {
      return sibling;
    }
    sibling = sibling.nextElementSibling;
  }

  sibling = element.previousElementSibling;

  while (sibling) {
    if (sibling.classList.contains(className)) {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
  return null;
}

window.addEventListener("DOMContentLoaded", function () {
  try {
    var productContainers = document.querySelectorAll(".product-container");

    productContainers.forEach(function (container) {
      var dataVariants = container.getAttribute("data-variants");
      var variants = JSON.parse(dataVariants);
      var swatches = container.querySelectorAll(".swatch");

      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          const swatchContainer = this.closest(".swatch-container");
          swatchContainer.querySelector(".selected_option span").textContent =
            this.getAttribute("data-value");
          swatchContainer
            .querySelector(".selected_option")
            .classList.remove("active");
          const swatchList = Array.from(
            swatchContainer.querySelectorAll(".swatch")
          );
          swatchList.forEach((s) => s.classList.remove("active"));
          this.classList.add("active");

          var selectedOptions = [];
          var optionContainers =
            container.querySelectorAll(".swatch-container");

          optionContainers.forEach(function (optionContainer) {
            var activeSwatch = optionContainer.querySelector(".swatch.active");
            if (activeSwatch) {
              selectedOptions.push(activeSwatch.getAttribute("data-value"));
            } else {
              selectedOptions.push(null);
            }
          });

          var selectedVariant = findVariant(variants, selectedOptions);
          if (selectedVariant) {
            container.setAttribute("data-variant-selected", selectedVariant.id);
            updateSoldOutStates(container, variants, selectedOptions);
            $(container)
              .siblings(".select_btn")
              .attr("data-vid", selectedVariant.id);
            if (selectedVariant.available) {
              $(container).siblings(".select_btn").removeClass("soldout");
            } else {
              $(container).siblings(".select_btn").addClass("soldout");
            }
          }
        });
      });
    });

    const selectedOptions = document.querySelectorAll(
      ".swatch-container .selected_option"
    );

    selectedOptions.forEach(function (selectedOption) {
      selectedOption.addEventListener("click", function (event) {
        event.stopPropagation();
        this.classList.toggle("active");
      });
    });

    document.addEventListener("click", function (event) {
      selectedOptions.forEach(function (selectedOption) {
        if (!selectedOption.contains(event.target)) {
          selectedOption.classList.remove("active");
        }
      });
    });
  } catch (e) {
    console.log(e);
  }
});

function findVariant(variants, selectedOptions) {
  return variants.find(
    (variant) =>
      variant.option1 == selectedOptions[0] &&
      variant.option2 == selectedOptions[1] &&
      variant.option3 == selectedOptions[2]
  );
}

function updateSoldOutStates(container, variants, selectedOptions) {
  const optionContainers = container.querySelectorAll(".swatch-container");

  optionContainers.forEach(function (optionContainer, index) {
    const swatches = optionContainer.querySelectorAll(".swatch");

    swatches.forEach(function (swatch) {
      const value = swatch.getAttribute("data-value");
      const currentSelectedOptions = [...selectedOptions];
      currentSelectedOptions[index] = value;

      const matchingVariant = findVariant(variants, currentSelectedOptions);
      if (matchingVariant && !matchingVariant.available) {
        swatch.classList.add("soldout_variant");
      } else {
        swatch.classList.remove("soldout_variant");
      }
    });
  });
}
/* variant picker */

try {
  $("body").delegate(".parent_item .quantity-selector", "click", function () {
    document.body.classList.add("refreshing_cart");
    setTimeout(function () {
      document.body.classList.remove("refreshing_cart");
    }, 6000);
  });

  $("body").delegate(
    ".parent_item .line-item__remove-button",
    "click",
    function () {
      document.body.classList.add("refreshing_cart");
      setTimeout(function () {
        document.body.classList.remove("refreshing_cart");
      }, 6000);
    }
  );
} catch (e) {}
$(function () {
  function bundleProductClose() {
    $(".product-bundle-popup-overlay").removeClass("open");
    $(".product-bundle-popup").removeClass("open");
  }
  function stepProducts(step) {
    var originalStep = step;
    if (step) {
      var step = step;
      $(".product-bundle-products-selection").each(function () {
        var firstBlank = $(this).find(
          ".product-bundle-add-product:not(.added):first"
        );
        $(".product-bundle-add-product").removeClass("first-blank");
        $(firstBlank).addClass("first-blank");
        step = $(firstBlank).attr("data-step");
      });
      step = step ? step : originalStep;
      if (originalStep) {
        step = originalStep;
      }
      $(
        ".bundle-popup-products .bundle-popup-products-block-wrapper"
      ).removeClass("open");
      let el = $(
        ".bundle-popup-products-block-wrapper[data-step='" + step + "']"
      );
      $(el).addClass("open");
    }
  }
  function bundleProductOpen(step) {
    $(".product-bundle-popup-overlay").addClass("open");
    $(".product-bundle-popup").addClass("open");
    $(
      ".bundle-popup-products .bundle-popup-products-block-wrapper"
    ).removeClass("open");

    if (step) {
      stepProducts(step);
    } else {
      $(".bundle-popup-products .bundle-popup-products-block-wrapper")
        .eq(0)
        .addClass("open");
    }
  }
  $(".product-bundle-popup-overlay").click(function () {
    bundleProductClose();
  });
  $(".bundle-popup-products-block-btn").click(function (e) {
    document.querySelector("#AddToCart").click();
    setTimeout(function () {
      bundleProductClose();
    }, 1);
  });
  $(".bundle-popup-close").click(function (e) {
    bundleProductClose();
  });
  $(".product-bundle-add-product").click(function (e) {
    bundleProductOpen($(this).attr("data-step"));

    stepProducts($(this).attr("data-step"));

    $(".product-bundle-add-product").removeClass("first-blank");
    var that = this;
    $(".product-bundle-products-selection").each(function () {
      var getClicked = $(this)
        .find(".product-bundle-add-product")
        .eq($(that).index());
      $(getClicked).addClass("first-blank");
    });
  });
  function setActiveProduct(vid, title, img, step) {
    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(
        `.product-bundle-add-product[data-step="${step}"]`
      );
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
    });

    $(".product-bundle-products-selection").each(function () {
      var firstElement = $(
        `.product-bundle-add-product[data-step="${step}"]:not(.added)`
      );
      firstElement.addClass("added");
      $(firstElement).attr("data-vid", vid);
      const pimg = `<img src="${img}" class="p-img">`;
      const ptitle = `<p class="p-title">${
        title.length > 35 ? title.substring(0, 25) + "..." : title
      }</p>`;
      $(firstElement).find(".product-bundle-add-product-img").append(pimg);
      firstElement.append(ptitle);

      var firstBlank = $(this).find(
        ".product-bundle-add-product:not(.added):first"
      );
      stepProducts($(firstBlank).attr("data-step"));
    });
  }
  function removeActiveProduct(varaintId, index) {
    let foundFirst = false;

    activeProducts = activeProducts.filter((el) => {
      if (!foundFirst && el.vid == varaintId) {
        foundFirst = true;
        return false;
      }
      return true;
    });

    $(".product-bundle-products-selection").each(function () {
      var removeEl = $(this).find(".product-bundle-add-product").eq(index);
      $(removeEl).removeClass("added");
      $(removeEl).removeAttr("data-vid");
      $(removeEl).find(".p-img").remove();
      $(removeEl).find(".p-title").remove();
    });

    updateDOM(activeProducts);
  }
  function updateDOM(activeProducts) {
    let activeProductsLength = activeProducts.length;
    $(".number-of-selected-items").text(activeProductsLength);
    let percent = (activeProductsLength / numberOfSteps) * 100;
    $(".product-bundle-popup .progress-bar-fill").css({
      width: percent + "%",
    });
    var buttons = document.querySelectorAll(".bundle-popup-products-block-btn");
    if (activeProductsLength == numberOfSteps) {
      // $(".bundle-popup-products-block-btn").removeAttr("disabled");
      $(".product-bundle-wrapper").addClass("filled");
      $(".product__info #AddToCart").removeAttr("disabled");
      $("#StickyAddToCart").removeAttr("disabled");
      buttons.forEach((button) => {
        const dataText = "Set in den Warenkorb packen";

        button.textContent = dataText;
      });
    } else {
      $(".product-bundle-wrapper").removeClass("filled");
      // $(".bundle-popup-products-block-btn").attr("disabled", true);
      // $(".product__info #AddToCart").attr("disabled", true);
      // $("#StickyAddToCart").attr("disabled", true);

      buttons.forEach((button) => {
        const dataText = button.getAttribute("data-text");

        button.textContent = dataText;
      });
    }

    var productPrice =
      parseFloat(
        document
          .querySelector(".price-list [data-ed-price]")
          .getAttribute("data-ed-price")
      ) / 100;
    var total = productPrice;
    var additionalPrices = [];

    // Der initiale Text wird später definiert, basierend darauf, ob Zusatzoptionen vorhanden sind
    var temp = "";

    activeProducts.forEach(function (el) {
      if (el.price > 0) {
        additionalPrices.push(el.price.toFixed(2) + "€"); // Fügt nur den Preis hinzu, wenn er größer als 0 ist
        total += parseFloat(el.price);
      }
    });

    // Zusätzliche Preise in den String einfügen, falls vorhanden
    if (additionalPrices.length > 0) {
      var additionalPricesString = additionalPrices.join(" + ");
      temp = `<strong>Set:</strong> ${productPrice}€ + Auswahl: ${additionalPricesString} = <strong class="final-price">${total.toFixed(
        2
      )}€</strong>`;
    } else {
      // Zeigt nur den Basispreis an, wenn keine Zusatzoptionen über 0€ gewählt wurden
      temp = `<strong>Set:</strong> ${productPrice}€`;
    }

    // Verwendung von .html() um sicherzustellen, dass HTML-Tags korrekt interpretiert werden
    // $(".product-bundle-popup-header-left").html(temp);
  }
  $(".select_btn").click(function (e) {
    e.preventDefault();
    var stepAdded = false;

    let step = $(this).attr("data-step");

    for (let item of activeProducts) {
      if (item.step == step) {
        stepAdded = true;
      }
    }

    if (!$(this).hasClass("soldout")) {
      let vid = $(this).attr("data-vid");
      let title = $(this).attr("data-title");
      let img = $(this).attr("data-img");
      let index = parseInt(
        $(this)
          .parents(".bundle-popup-products-block-wrapper")
          .attr("data-index")
      );
      let price = parseFloat(
        $(this).find(".bundle-product-price").text().replace(",", ".")
      );
      let optional = $(this).attr("data-optional") === "1" ? true : false;

      activeProducts = activeProducts.filter(function (item) {
        return item.step !== step;
      });

      if (activeProducts.length != numberOfSteps) {
        activeProducts.push({
          vid,
          title,
          img,
          step,
          price,
          optional,
          index,
        });
        setActiveProduct(vid, title, img, step);
        updateDOM(activeProducts);
      } else {
      }
    }
  });

  $(".bundle-product-cross").click(function (e) {
    e.preventDefault();
    let parent = $(this).parents(".product-bundle-add-product");
    removeActiveProduct($(parent).attr("data-vid"), $(parent).index());
  });

  $(".bundle-popup-products-filter-menu ul").on("click", "li", function () {
    var dataColHandle = $(this).attr("data-col-handle");
    $(this)
      .closest(".bundle-popup-products-block-wrapper")
      .find(".bundle-popup-products-block")
      .removeClass("active");
    $(this)
      .closest(".bundle-popup-products-block-wrapper")
      .find(`.bundle-popup-products-block[data-col-handle="${dataColHandle}"]`)
      .addClass("active");
  });
});

/* bundle builder */

document.addEventListener('variant:changed', this.customOnVariantChange.bind(this));

function customOnVariantChange(e){
  console.log("variant changed"+e.detail.variant.id);

  var elements = document.getElementsByClassName("customVariantSubTitle");
  for (var i in elements){
    if(elements[i] &&  elements[i].style && elements[i].style.display){
          elements[i].style.display = "none";
    }
  }
  var elementId = "product-variant-teaser-"+ e.detail.variant.id;
  if (document.getElementById(elementId)){
      document.getElementById(elementId).style.display = "block";
  }

  setTimeout(function(){
     var colorTexts = document.getElementsByClassName("product-form__option-value"); 
    for (var i in colorTexts){
      if (colorTexts[i] && colorTexts[i].textContent && colorTexts[i].textContent.includes("Gold")){
        colorTexts[i].textContent = "Gold";
        var optionElement = document.getElementById("option-value-custom");
        optionElement.textContent = "Gold";
      }
      if (colorTexts[i] && colorTexts[i].textContent && colorTexts[i].textContent.includes("Silber")){
        colorTexts[i].textContent = "Silber";
        var optionElement = document.getElementById("option-value-custom");
        optionElement.textContent = "Silber";
      }
    }
  },50);
 
  }

document.addEventListener('scroll', function(event) {
  var annoucementBar1;
  var annoucementBar2;
  var threshold = window.location.href.includes("product")?400:Math.max(  document.body.scrollHeight, document.documentElement.scrollHeight,   document.body.offsetHeight, document.documentElement.offsetHeight,  document.body.clientHeight, document.documentElement.clientHeight) / 3;

  if(!annoucementBar1 && !annoucementBar2){
    annoucementBar2 = document.getElementById('announcement-bar');
    annoucementBar1 = document.getElementById('ed-additional-announcement-bar');
  }
  
  if(window.scrollY > 50 && annoucementBar2){
       annoucementBar2.classList.add("fade");
  }
  
  if(window.scrollY > threshold && annoucementBar1){
     annoucementBar1.classList.add("fade");

  }

  if(window.scrollY < 50 && annoucementBar2){
       annoucementBar2.classList.remove("fade");
  }
  
  if(window.scrollY < threshold && annoucementBar1){
     annoucementBar1.classList.remove("fade");

  }
  
});


